import React, { Component } from "react";
import { switchReportStyle } from "../../Timps/Switch/style";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import ReportFraConditionsMasterKey from "../../../../libraries/ReportGenerator/ReportFraConditionsMasterKey";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { TrackViolationReportSchema } from "./trackViolationReportSchema";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { SignatureImageImproved } from "../../utils/SignatureImage";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";

const ReportTableFooter = () => {
  return (
    <thead>
      <tr>
        <th colSpan={20} className="tbl-bordered-header text-left pd-left-5px pd-top-10px pd-bottom-10px">
          <span>
            Public reporting burden for this information collection is estimated to average 4 hours per response, including the time for
            reviewing instructions, searching existing data sources, gathering and maintaining the data needed, and completing and reviewing
            the collection of information. According to the Paperwork Reduction Act of 1995, a federal agency may not conduct or sponsor,
            and a person is not required to respond to, nor shall a person be subject to a penalty for failure to comply with, a collection
            of information unless it displays a currently valid OMB control number. The valid OMB control number for this information
            collection is 2130-0509. All responses to this collection of information are mandatory. Send comments regarding this burden
            estimate or any other aspect of this collection, including suggestions for reducing this burden to: Information Collection
            Officer, Federal Railroad Administration, 1200 New Jersey Avenue, SE, Washington, D.C. 20590.{" "}
          </span>
        </th>
      </tr>
    </thead>
  );
};

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { location, user, date, formSummary, subdivision } = reportData;
  if (!formSummary) formSummary = {};

  let data = {
    lineName: subdivision,
    location: location,
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
    signatureImage: props.signatureImage,
  };

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Track Violation Report" {...props} fontSizeOverride={"35px"} centerTitle={true} />

      <span className="spacer"></span>

      <table className="table-bordered" style={{ fontSize: "20px" }}>
        {TrackViolationReportSchema.sections.map((section) => {
          return <ReportTableSectionRenderer section={section} rowsData={data} />;
        })}
        <ReportTableFooter />
      </table>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <h3>Form FRA F6180.111 (9/04)</h3>
        <h3>OMB approval expires 05/31/2022</h3>
      </div>
    </div>
  );
};

const FRA_TrackViolationReport = (props) => {
  const { inspec, isPreview, signatureImage } = props;
  let formSummaries = ReportGeneratorUtils.getInspectionTableAppForms(inspec, ["trackViolationReportForm"]);

  return formSummaries.map((summary, _i) => (
    <ReportView
      key={_i}
      {...props}
      reportData={{
        formSummary: summary,
        location: ReportGeneratorUtils.getInspectionLocation(inspec),
        subdivision: ReportGeneratorUtils.getInspectionSubdivision(inspec),
        date: ReportGeneratorUtils.getInspectionDate(inspec),
        user: ReportGeneratorUtils.getInspectionUser(inspec),
        signatureImage: signatureImage,
      }}
    />
  ));
};

export default FRA_TrackViolationReport;



// WEBPACK FOOTER //
// ./src/components/Reports/FRA/TrackViolationReport/index.jsx